import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {jwtDecode} from "jwt-decode";
import { ITokenModel } from "Models/ITokenModel";

const AuthProtected = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("authUser");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  let tokendata: ITokenModel = jwtDecode(token);
  let roleId = parseInt(tokendata.RoleId, 10);

  if (!allowedRoles || !allowedRoles.includes(roleId)) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default AuthProtected;
